import { AgeGate } from './AgeGate';

export default AgeGate;
export type { AgeGateProps } from './types';
